import * as React from "react";
import { matchPath } from "react-router-dom";
import * as links from "./links";
import * as types from "./types";

export const getHeaderLinks: types.GetHeaderLinks = ({
  authData,
  t,
  online,
  isStudentWithAssignmentHomePage,
  isStudentFromGoogleClass,
  isHigherGradeLevel,
}) => {
  if (authData.user.profileType === "Teacher") {
    return links.teacherSidebarLinks(authData, t, online);
  }
  if (authData.user.profileType === "Administrator") {
    return links.adminSidebarLinks(authData, t, online);
  }
  if (isStudentFromGoogleClass) {
    if (isHigherGradeLevel) {
      return links.studentSidebarLinks(
        authData,
        t,
        online,
        isStudentWithAssignmentHomePage,
      );
    }
    return links.googleStudentSidebarLinks(authData, t, online);
  }
  if (
    authData.user.profileType === "Student" &&
    !authData.user.kindergartenDesign
  ) {
    return links.studentSidebarLinks(
      authData,
      t,
      online,
      isStudentWithAssignmentHomePage,
    );
  }
  if (authData.user.kindergartenDesign) {
    return links.kindergartenSidebarLinks(authData, t, online);
  }
  return [];
};

export const getRoutes: types.GetRoutes = (opts) => {
  const registeredRefs: {
    [key: string]: React.RefObject<HTMLLIElement | null>;
  } = {};
  const registeredRoutes = getHeaderLinks(opts);

  registeredRoutes.forEach((route) => {
    registeredRefs[route.path] = React.createRef<HTMLLIElement>();
  });

  return { routes: registeredRoutes, refs: registeredRefs };
};

export const isPathMatch: types.IsPathMatch = (link, pathname) =>
  !!link.descendants?.some((path) => matchPath({ path }, pathname));

export const isBundles: types.IsBundles = (link, params) =>
  link.path.match("bundles")
    ? params.view === "bundles"
    : params.view !== "bundles";
